import "isomorphic-fetch";
// import { devheaders } from '../api';
import { API_BASE_URL } from '../config/api';
import { assetsConstants } from '../_constants';
import { history } from '../_helpers';
import { checkUnauthorized } from '../_helpers/handleResponse';
import { fetchWithAuth } from '../_helpers/fetchWithAuth';
import { runCachedRequest } from '../_helpers/requestCache';
import { nodeConstants } from '../_constants';
const API = API_BASE_URL;
// const lang = 'de';
// const headers = {
//   'Accept': 'application/json',
//   'Content-Type': 'application/json',
//   'Authorization': `celumApiKey ${APIKEY}`
// }


// export const NODES_HAS_ERRORED = 'NODES_HAS_ERRORED';
// export const NODES_IS_LOADING = 'NODES_IS_LOADING';
// export const NODES_FETCH_DATA_SUCCESS = 'NODES_FETCH_DATA_SUCCESS';


function assetsHasErrored(bool) {
  return {
    type: assetsConstants.ASSETS_HAS_ERRORED,
    hasErrored: bool
  };
}

function assetsIsLoading(bool) {
  return {
    type: assetsConstants.ASSETS_IS_LOADING,
    isLoading: bool
  };
}

function assetsFetchDataSuccess(assets) {
  return {
    type: assetsConstants.ASSETS_FETCH_DATA_SUCCESS,
    assets
  };
}

export function assetsFetchData(id) {
  return async (dispatch) => {
    dispatch(assetsIsLoading(true));
    try {
      const response = await runCachedRequest(
        `node-assets:${id}:files=true`,
        () => fetchWithAuth(API+`/nodes/${id}?includeAssets=true&includeFiles=true`, {
          method: 'GET',
        }),
        { ttl: 30 * 1000 },
      );

      if (!response.ok) {
        checkUnauthorized(response, response.statusText);
        if(response.status === 403)
          history.push('/login');
        throw Error(response.statusText);
      }

      const node = await response.json();
      dispatch({
        type: nodeConstants.NODE_FETCH_DATA_SUCCESS,
        nodes: node,
        id,
      });
      dispatch(assetsFetchDataSuccess(node.assets || []));
      dispatch(assetsIsLoading(false));
      return node.assets || [];
    } catch (error) {
      dispatch(assetsHasErrored(true));
      dispatch(assetsIsLoading(false));
      throw error;
    }
  };
}
